import Model, { attr, hasMany } from '@ember-data/model';
import classic from 'ember-classic-decorator';

@classic
export default class DocumentRequestContactInfoConnectionModel extends Model {
  @hasMany('insurance-card', { async: false }) insuranceCards;

  @attr() insuranceCardFrontId;
  @attr() insuranceCardBackId;

  @hasMany('photo-id', { async: false }) photoIds;

  @attr() photoIdFrontId;
  @attr() photoIdBackId;
}
